import { RouteConfig } from "vue-router";
import { UserState } from "@/store/modules/auth/interfaces";

export const recruiter_interview_routes: RouteConfig = {
  path: "interviews",
  component: () => import("@/views/recruiter/interview/InterviewIndex.vue"),
  meta: {
    user_state: [UserState.RECRUITER, UserState.RECRUITER_ADMIN]
  },
  children: [
    {
      path: "",
      name: "recruiter-interviews",
      component: () =>
        import("@/views/recruiter/interview/InterviewListing.vue"),
      meta: {
        name: "nav-sidebar.interviews",
        icon: require("@/assets/icons/nav_sidebar/active/teacher.svg"),
        user_state: [UserState.RECRUITER, UserState.RECRUITER_ADMIN]
      }
    },
    {
      path: "ai-agent",
      name: "recruiter-ai-interview-agent",
      component: () =>
        import(
          "@/views/recruiter/interview/RecruiterAiInterviewAgentListing.vue"
        ),
      meta: {
        name: "nav-sidebar.ai-interview-agent",
        icon: require("@/assets/icons/nav_sidebar/active/candidates.svg"),
        user_state: [UserState.RECRUITER, UserState.RECRUITER_ADMIN]
      }
    },
    {
      path: "person-agent",
      name: "recruiter-person-interview-agent",
      component: () =>
        import("@/views/recruiter/interview/RecruiterPersonInterviewAgentListing.vue"),
      meta: {
        name: "nav-sidebar.person-interview-agent",
        icon: require("@/assets/icons/nav_sidebar/active/candidates.svg"),
        user_state: [UserState.RECRUITER, UserState.RECRUITER_ADMIN]
      }
    },
    {
      path: "person-agent/details",
      name: "recruiter-person-interview-details",
      component: () =>
        import("@/views/recruiter/interview/RecruiterPersonInterviewDetails.vue"),
      meta: {
        name: "nav-sidebar.person-interview-agent",
        icon: require("@/assets/icons/nav_sidebar/active/candidates.svg"),
        user_state: [UserState.RECRUITER, UserState.RECRUITER_ADMIN]
      }
    },
    {
      path: "person-agent/report",
      name: "recruiter-person-interview-report",
      component: () =>
        import("@/views/recruiter/interview/RecruiterPersonInterviewReport.vue"),
      meta: {
        name: "nav-sidebar.person-interview-agent",
        icon: require("@/assets/icons/nav_sidebar/active/candidates.svg"),
        user_state: [UserState.RECRUITER, UserState.RECRUITER_ADMIN]
      }
    },
    {
      path: "person-agent/guidelines",
      name: "recruiter-person-interview-guidelines",
      component: () =>
        import("@/views/recruiter/interview/RecruiterInterviewGuidelines.vue"),
      meta: {
        name: "nav-sidebar.person-interview-agent",
        icon: require("@/assets/icons/nav_sidebar/active/candidates.svg"),
        user_state: [UserState.RECRUITER, UserState.RECRUITER_ADMIN]
      }
    },
    {
      path: "ai-agent/details",
      name: "recruiter-ai-interview-details",
      component: () =>
        import("@/views/recruiter/interview/RecruiterAiInterviewDetails.vue"),
      meta: {
        name: "nav-sidebar.ai-interview-agent",
        icon: require("@/assets/icons/nav_sidebar/active/candidates.svg"),
        user_state: [UserState.RECRUITER, UserState.RECRUITER_ADMIN]
      }
    },
    {
      path: "ai-agent/report",
      name: "recruiter-ai-interview-report",
      component: () =>
        import("@/views/recruiter/interview/RecruiterAiInterviewReport.vue"),
      meta: {
        name: "nav-sidebar.ai-interview-agent",
        icon: require("@/assets/icons/nav_sidebar/active/candidates.svg"),
        user_state: [UserState.RECRUITER, UserState.RECRUITER_ADMIN]
      }
    },
    {
      path: "ai-agent/guidelines",
      name: "recruiter-ai-interview-guidelines",
      component: () =>
        import("@/views/recruiter/interview/RecruiterInterviewGuidelines.vue"),
      meta: {
        name: "nav-sidebar.ai-interview-agent",
        icon: require("@/assets/icons/nav_sidebar/active/candidates.svg"),
        user_state: [UserState.RECRUITER, UserState.RECRUITER_ADMIN]
      }
    }
  ]
};
